import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { getTime, endOfDay } from 'date-fns'
import DatePicker from 'react-datepicker'
import moment from 'moment-timezone'
import { useTranslation } from 'react-i18next'

import API from '../../../api/api'
import { formatMoney } from '../../../helpers/helpers'

const AnalyticsWidget = ({ buildingId, buildingTimezone }) => {
  const { t } = useTranslation(['parking-dashboard'])
  const [analyticsData, setAnalyticsData] = useState({})
  const [[startDate, endDate], setPeriod] = useState([null, null])

  const handleChangeDateFilterValue = ([newStartDate, newEndDate]) => {
    setPeriod([newStartDate, newEndDate ? getTime(endOfDay(newEndDate)) : null])
  }

  const renderTimeString = (timeInMins) => {
    if (timeInMins >= 60) {
      const hours = Math.floor(timeInMins / 60)
      const mins = timeInMins - hours * 60
      return t('parking-dashboard:analytics.hoursAndMinutes', { hours, mins })
    }
    return t('parking-dashboard:analytics.minutes', { mins: timeInMins })
  }

  useEffect(() => {
    ;(async () => {
      const resp = await API.getParkingAnalytics({
        buildingId,
        ...(startDate &&
          !Number.isNaN(startDate) && {
            startDate: moment(startDate).tz(buildingTimezone, true).valueOf(),
          }),
        ...(endDate &&
          !Number.isNaN(endDate) && {
            endDate: moment(endDate).tz(buildingTimezone, true).valueOf(),
          }),
      })
      setAnalyticsData(resp.data)
    })()
  }, [buildingId, startDate, endDate])

  return (
    <div className="analytics-widget">
      <div>
        <div className="data-reports-container">
          <div className="analytics-title">{t('parking-dashboard:analytics.dataReports')}</div>
          <div className="date-picker-container">
            <DatePicker
              className={'input borderless'}
              selectsRange={true}
              placeholderText={t('parking-dashboard:selectTimeRange')}
              isClearable={true}
              maxDate={new Date()}
              onChange={handleChangeDateFilterValue}
              startDate={startDate}
              endDate={endDate}
              popperClassName="parking-date-picker-popper"
            />
          </div>
        </div>
        <div className="analytics-wrapper">
          <div className="analytics-row">
            <div className="analytics-data-title">
              {t('parking-dashboard:analytics.serviceFeeTotal')}
            </div>
            <div>{formatMoney((analyticsData.totalServiceFee || 0) / 100)}</div>
          </div>
          <div className="analytics-row">
            <div className="analytics-data-title">{t('parking-dashboard:columns.tips')}</div>
            <div>{formatMoney((analyticsData.totalTips || 0) / 100)}</div>
          </div>
          <div className="analytics-row">
            <div className="analytics-data-title">
              {t('parking-dashboard:analytics.vehiclesCheckedOutTotal')}
            </div>
            <div>{analyticsData.totalVehicles}</div>
          </div>
          <div className="analytics-row">
            <div className="analytics-data-title">
              {t('parking-dashboard:analytics.averageTimeToCheckout')}
            </div>
            <div>{renderTimeString(analyticsData.checkoutAvgTime)}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

AnalyticsWidget.propTypes = {
  buildingId: PropTypes.number,
  buildingTimezone: PropTypes.string,
}

export default AnalyticsWidget
